import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import VueCookies from 'vue-cookies'
import VeeValidate from 'vee-validate'
import $ from 'jquery'
import routes from './routes.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import mixin from './mixins/amount-functions.js'
import Vue2Filters from 'vue2-filters'
import VueTextareaAutosize from 'vue-textarea-autosize'
import VueQuillEditor from 'vue-quill-editor'
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels';

Vue.use(VueQuillEditor)

// configure language
locale.use(lang)
require('sweetalert2/dist/sweetalert2.min.css')

const config = {
    errorBagName: 'errors', // change if property conflicts.
    fieldsBagName: 'inputs ', //default fields
    delay: 0,
    locale: 'en',
    dictionary: null,
    strict: true
}

// We want to apply VueResource and VueRouter
// to our Vue instance
Vue.use(VueResource)
Vue.use(VueRouter)
Vue.use(VueCookies)
Vue.use(VeeValidate, config)
Vue.use(ElementUI)
Vue.mixin(mixin)
Vue.use(Vue2Filters)
Vue.use(VueTextareaAutosize)

// Global components
import AppHeader from './components/Header.vue'
import Footer from './components/Footer.vue'

const router = new VueRouter({
    routes, // short for routes: routes
    linkActiveClass: 'active',
    history: true
})

// protect routes. Allow user which are logged in
router.beforeEach((to, from, next) => {
    var cookies = VueCookies
    
    var user = JSON.parse(cookies.get('teltonika_session_content'))
    
    if (to.path !== '/login' && to.name !== 'register' && to.path !== '/commercial-offers') {
        // if token is not set redirect to /login
        if (cookies.get('teltonika_session') === null) {
            next({
                path: '/login'
            })
        } else {
            if (to.path !== '/otp' && cookies.get('teltonika_verified') != 'true') {
                next({
                    path: '/otp'
                })   
            }
            {
            if (to.path === '/commercial-offers') {
                next({
                    path: '/commercial-offers'
                })   
            }
            else {
                if(to.meta.roles[user.user_type]){
                    next()
                }else{
                    next({
                        path: '/forbidden'
                    }) 
                }
            }
        }
        }
    } else {
        if (cookies.get('teltonika_session') !== null) {
            
            var path = 'otp'

            if(cookies.get('teltonika_verified') == 'true')
            {
                path = 'items'
                if(user.user_type == 'hq_warehouse')
                {
                    path = 'backlog'
                }
            }
    
            next({
                path: '/' + path
            })
        } else {
            next()
        }
    }
    if (!to.query.page) {
        $('html, body').animate({
            scrollTop: 0
        }, 'slow')
    }
})

Vue.http.interceptors.push((request, next)  => {
    next((response) => {
        let token = ""
        if(token = response.headers.get('authorization')){
            if(token != Vue.cookies.get('teltonika_session')){
                Vue.cookies.set('teltonika_session', token)
            }
        }
    })
});

new Vue({
    data () {
        return {
            newEndpoint: process.env.API_NEW_ENDPOINT,
            user:{},
            quotationRequestUrl: '',
            isEditFromQuotationsPage: false,
            date_picker_options:{
                firstDayOfWeek: 1
            },
            editorOption: {
              modules: {
                toolbar: [
                  ['bold', 'italic', 'underline'],
                  [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                  [{ 'size': ['small', false, 'large', 'huge'] }],
                  [{ 'font': [] }],
                  [{ 'align': [] }]
                ]
              }
            },
            moneyOption:{
                decimal: '.',
                thousands: ',',
                precision: 2,
                masked:false
            },
            numberOption:{
                decimal: '.',
                thousands: ',',
                precision: 0,
                masked:false
            },
            moneyOptionPrecisionOne:{
                decimal: '.',
                thousands: ',',
                precision: 1,
                masked:false
            },
            moneyOptionPrecisionThree:{
                decimal: '.',
                thousands: ',',
                precision: 3,
                masked:false
            },
            moneyOptionPrecisionFour:{
                decimal: '.',
                thousands: ',',
                precision: 4,
                masked:false
            }
        }
    },
    computed: {
        headers(){
            return {
                'Authorization':'Bearer ' + this.$cookies.get('teltonika_session')
            }
        },
        userRole () {
          let role = this.user ? this.user.user_type : ''
          if (role === 'supervisor') {
            role = 'admin'    
          }
          return role
        },
        user_role(){
            return this.user ? this.user.user_type : ''
        },
        isAdmin(){
            return this.user && this.user.user_type === 'admin'
        },
        anAdmin(){
            return this.user && this.user.user_type === 'admin'
        },
        isSuperVisor () {
          return this.user && this.user.user_type === 'supervisor'  
        },
        isSuperVisorOrAdmin () {
          return this.user && (this.user.user_type === 'supervisor' || this.user.user_type === 'admin')
        },
        isClient(){
            return this.user && (this.user.user_type === 'client' || this.user.user_type === 'client_p')
        },
        isHqTop(){
            return this.user && this.user.user_type === 'hq_top' 
        },
        isRandD(){ //Warehouse
            return this.user && this.user.user_type === 'r_and_d' 
        },
        isWarehouse(){ //Warehouse
            return this.isRandD
        },
        isQc(){
            return this.user && this.user.user_type === 'qc' 
        },
        isPurchaser(){
            return this.user && this.user.user_type === 'purchaser' 
        },
        userName () {
          return this.user ? this.user.name : ''
        },
        isRDOrQC(){
            return this.user && (this.user.user_type == 'r_and_d' || this.user.user_type == 'qc')
        },
        isHQOrClientOrQC () {
          return this.user && (this.user.user_type === 'hq_top' || this.user.user_type === 'client' || this.user.user_type === 'qc' || this.user.user_type === 'client_p')
        },
        isClientPlus(){
            return this.user && this.user.user_type === 'client_p' 
        },
        isHQWarehouse(){ //Warehouse
            return this.user && this.user.user_type === 'hq_warehouse' 
        },
    },
    components: {
        'app-header': AppHeader,
        'app-footer': Footer,
        ChartJsPluginDataLabels
    },
    watch: {
        '$route.fullPath' () {
            // if ($route.fullPath)
            if (this.userRole === 'purchaser' && (this.$route.fullPath.indexOf('/items') || this.$route.fullPath.indexOf('/backlog') || this.$route.fullPath.indexOf('/quotations') || this.$route.fullPath.indexOf('/vendors') ) ) {
                this.$router.replace(this.$route.fullPath)
            } else {
                if (this.userRole === 'purchaser') {
                    this.$router.replace('/items')
                }
            }
        }
    },
    created () {

        this.user = JSON.parse(this.$cookies.get('teltonika_session_content'))
       
        if (this.userRole === 'purchaser') {
          //this.$router.replace('/items')
        }
        if (this.userRole === 'client' || this.userRole == 'hq_top') {
          //this.$router.replace('/client/commercial-offers')
        }
        if (this.userRole === 'qc') {
          //this.$router.replace('/auth-commercial-offers')
        }
    },
    methods: {
        getRequest: function(params)
        {
            return this.$http.get(process.env.API_NEW_ENDPOINT + params, {
                headers: {
                    'Authorization': 'Bearer ' + this.$cookies.get('teltonika_session') 
                }
            })
        },
        postRequest: function(params, data)
        {
            return this.$http.post(process.env.API_NEW_ENDPOINT + params, data, {
                headers: {
                    'Authorization': 'Bearer ' + this.$cookies.get('teltonika_session') 
                }
            })
        },
        putRequest: function(params, data)
        {
            return this.$http.put(process.env.API_NEW_ENDPOINT + params, data, {
                headers: {
                    'Authorization': 'Bearer ' + this.$cookies.get('teltonika_session') 
                }
            })
        },
        deleteRequest: function(params, data)
        {
            return this.$http.delete(process.env.API_NEW_ENDPOINT + params, {
                data: data,
                headers: {
                    'Authorization': 'Bearer ' + this.$cookies.get('teltonika_session') 
                }
            })
        },
        isAdmin: function () {
            if(this.user){
                if (this.user.user_type === 'admin') {
                    return true
                } else {
                    return false
                }
            }
        },
        isCommercialOffer: function () {
            return this.$route.path === 'commercial-offers' ? true : false 
        },
        range: function(min,max){
            var array = [], j = 0;
            for(var i = min; i <= max; i++){
                array[j] = i;
                j++;
            }
            return array;
        },
        hasDuplicateAccess: function(){
            if(this.$root.userRole == 'purchaser' ){
                return true
            }

            if(this.$root.userRole == 'admin' ){
                return true
            }

            if(this.$root.userRole == 'supervisor' ){
                return true
            }

            return false
        }
    },
    router
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js